import type { FC } from 'react';
import React from 'react';

import { useArticleDataContext } from '../article-data-provider/context';
import { isArticleExists } from '../../helpers/is-article-exists';

import type { TArticleFiles } from './models';

export const ArticleFiles: FC<TArticleFiles> = ({ FileLink, className }) => {
    const { article } = useArticleDataContext();

    if (!isArticleExists(article)) {
        return null;
    }

    if (!article.files) {
        return null;
    }

    return (
        <section className={className}>
            {article.files
                .filter(item => item.type === 'attach')
                .map(({ link, name }) => (
                    <FileLink key={name} fileName={name} link={link} />
                ))}
        </section>
    );
};
